import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=a9764548&scoped=true&"
import script from "./MainHeader.vue?vue&type=script&lang=js&"
export * from "./MainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MainHeader.vue?vue&type=style&index=1&id=a9764548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9764548",
  null
  
)

export default component.exports